import { t } from "@lingui/macro";
import * as React from "react";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const PunchPassAvailableIcon = (props: IconProps) => (
  <Icon
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    title={t`Punch Pass Available`}
    {...props}
  >
    <G clipPath="url(#clip0_14872_39152)">
      <Path
        d="M3.0332 13.1963C3.03312 12.9975 2.95405 12.8066 2.81348 12.666L1.17578 11.0283C0.608116 10.4603 0.608116 9.53973 1.17578 8.97168L2.81348 7.33398C2.95405 7.19341 3.03312 7.00251 3.0332 6.80371V4.48828C3.0332 3.68481 3.68481 3.0332 4.48828 3.0332H6.80371C7.00251 3.03312 7.19341 2.95405 7.33398 2.81348L8.97168 1.17578C9.53973 0.608116 10.4603 0.608116 11.0283 1.17578L12.666 2.81348C12.8066 2.95405 12.9975 3.03312 13.1963 3.0332H15.5127C16.3159 3.03346 16.9668 3.68497 16.9668 4.48828V6.80371C16.9668 7.00255 17.046 7.19335 17.1865 7.33398L18.8242 8.97168C19.3919 9.53973 19.3919 10.4603 18.8242 11.0283L17.1865 12.666C17.046 12.8067 16.9668 12.9974 16.9668 13.1963V15.5127C16.9665 16.3158 16.3158 16.9665 15.5127 16.9668H13.1963C13.0472 16.9668 12.9025 17.0113 12.7803 17.0928L12.666 17.1865L11.0283 18.8242C10.4603 19.3919 9.53973 19.3919 8.97168 18.8242L7.33398 17.1865C7.19335 17.046 7.00255 16.9668 6.80371 16.9668H4.48828C3.68497 16.9668 3.03346 16.3159 3.0332 15.5127V13.1963Z"
        fill="white"
        stroke="#ACE5CF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <G clipPath="url(#clip1_14872_39152)">
        <Path
          d="M13.5 6.5L6.5 13.5"
          stroke="#1DAA75"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M6.80469 6.79199H6.81914"
          stroke="#1DAA75"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M13.207 13.1924H13.2215"
          stroke="#1DAA75"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="clip0_14872_39152">
        <Rect width="20" height="20" fill="white" />
      </ClipPath>
      <ClipPath id="clip1_14872_39152">
        <Rect width="20" height="20" fill="white" />
      </ClipPath>
    </Defs>
  </Icon>
);
